import { Targets } from '@atlassiansox/cross-flow-support';
export const AtlassianAppTargets = {
  CONFLUENCE: Targets.CONFLUENCE,
  JIRA_CORE: Targets.JIRA_CORE,
  JIRA_SERVICE_DESK: Targets.JIRA_SERVICE_DESK,
  JIRA_SOFTWARE: Targets.JIRA_SOFTWARE,
  JIRA_PRODUCT_DISCOVERY: Targets.JIRA_PRODUCT_DISCOVERY,
  BITBUCKET: 'com.atlassian.bitbucket',
  TRELLO: Targets.TRELLO,
  OPSGENIE: Targets.OPSGENIE,
  STATUSPAGE: Targets.STATUSPAGE,
  COMPASS: Targets.COMPASS,
  LOOM: Targets.LOOM
};